import { render, staticRenderFns } from "./InspirationItemsManage.vue?vue&type=template&id=010bd553"
import script from "./InspirationItemsManage.vue?vue&type=script&lang=js"
export * from "./InspirationItemsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports